export default "__VITE_ASSET__OmvJUmsk__"